import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as display from '../../../../display'
import * as relay from '../../../../relay'
import type { TypeParams } from '../../types'

import { getActionsConfig } from './actions'
import { Api } from './api'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Requests the currently open Space report be generated as a file, via the
 * backend (see extra.space.reports.requestFileGeneration) instead of building
 * the workbook in the browser. Generation runs in the background — the file
 * becomes downloadable from the processes slideout once it's ready
 */
export class Plugin extends ec.plugins.Plugin<
  TypeParams,
  typeof Plugin.id,
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  public static readonly id = ec.plugins.Plugin.Id.Custom.create(
    'SpaceReportDownload',
  )

  /** @see {@link Api} */
  public readonly api: Api = ngCore.inject(Api)

  constructor({ collection }: Readonly<Plugin.constructor.Params>) {
    const toasterFeature = ngCore.inject(display.toaster.Feature)
    const processesFeature = ngCore.inject(relay.processes.Feature)

    super({
      actions: getActionsConfig(),
      collection,
      id: Plugin.id,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })

    this.feature.registerEffects(
      effects.downloadOnRequest(this),
      effects.showToastOnDownloadSuccess(toasterFeature, processesFeature),
    )
  }
}
export namespace Plugin {
  export namespace constructor {
    export type Params = Pick<
      ec.plugins.Plugin.Default<TypeParams>,
      'collection'
    >
  }
}
